import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import './AddCategoryOrTag.css';

class AddCategoryOrTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: null
    };
  }
  render() {
    const { index } = this.props;
    const keyword = index === 1 ? 'Categories' : 'Tags';

    return (
      <div className="add-category-modal-container">
        <div className="heading"> Add {keyword}</div>
        <div style={{ fontSize: '18px' }}>
          You can add multiple {keyword.toLocaleLowerCase()} by separating each one with a comma.
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '20px',
            paddingLeft: '80px',
            paddingRight: '150px'
          }}
        >
          <label
            style={{ fontSize: '20px', fontWeight: 'bold', paddingTop: '5px' }}
          >
            {' '}
            {index === 1 ? 'Category ' : 'Tag '} Names:
          </label>
          <input
            className="input-categories"
            onChange={(e) => this.setState({ list: e.target.value })}
          ></input>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            className="orange-button"
            onClick={() => {
              this.props.listOfCategoriesOrTags(index, this.state.list);
            }}
          >
            {' '}
            Save{' '}
          </Button>
        </div>
      </div>
    );
  }
}

export default AddCategoryOrTag;
